function m7InstallSvgZonePicker(){
  const editor=document.getElementById("m7WrapEditor");
  if(!editor||editor.dataset.m7SvgPicker==="true")return;
  editor.dataset.m7SvgPicker="true";
  let pointerStart=null;
  let clickAllowed=true;
  const shapeSelector="path,polygon,polyline,rect,circle,ellipse";
  const partSelectors={PART_SKIS:["SKIS"],PART_SKI_HANDLES:["SKI_HANDLES"],PART_SPINDLES:["SPINDLES"],PART_TRACK:["RAILS"],PART_BUMPERS:["BUMPERS"],PART_SEAT:["SEAT"]};

  function activateRole(role){
    function selectRole(){
      const groupName=role.startsWith("PART_")?"parts":"wrap";
      const groupButton=editor.querySelector(`[data-m7-group="${groupName}"]`);
      if(groupButton&&!groupButton.classList.contains("active")){
        groupButton.click();
        return requestAnimationFrame(selectRole);
      }
      const zoneButton=editor.querySelector(`[data-m7-zone="${role}"]`);
      if(zoneButton){
        zoneButton.click();
        zoneButton.focus({preventScroll:true});
      }
    }
    const colorsTab=editor.querySelector('[data-m7-tab="custom"]');
    if(colorsTab&&!colorsTab.classList.contains("active")){
      colorsTab.click();
      requestAnimationFrame(selectRole);
    }else selectRole();
  }

  function shapesInside(node){
    if(!node)return[];
    return node.matches?.(shapeSelector)?[node]:[...node.querySelectorAll?.(shapeSelector)||[]];
  }

  function roleAtPoint(x,y){
    const svg=editor.querySelector(".sled-svg-wrapper svg");
    if(!svg||typeof getEditableSvgLayer!=="function"||typeof getWrapColorNodes!=="function")return"";
    const all=[...svg.querySelectorAll("*")];
    const saved=all.map(node=>[node,node.style.pointerEvents]);
    const disableAll=()=>all.forEach(node=>{node.style.pointerEvents="none";});
    const findPaintedRole=roleMap=>{
      disableAll();
      roleMap.forEach((role,shape)=>{shape.style.pointerEvents="visiblePainted";});
      const painted=document.elementFromPoint(x,y);
      for(let node=painted;node&&node!==svg;node=node.parentElement){
        const role=roleMap.get(node);
        if(role)return role;
      }
      return"";
    };

    let role="";
    try{
      const accents=getEditableSvgLayer(svg,"accents");
      const partMap=new Map();
      if(accents)Object.entries(partSelectors).forEach(([partRole,ids])=>ids.forEach(id=>{
        shapesInside(accents.querySelector(`#${CSS.escape(id)}`)).forEach(shape=>partMap.set(shape,partRole));
      }));
      role=findPaintedRole(partMap);

      if(!role){
        const wrap=getEditableSvgLayer(svg,"wrap");
        const wrapMap=new Map();
        if(wrap)for(let number=1;number<=10;number++){
          const colorRole=`COLOR_${number}`;
          getWrapColorNodes(wrap,colorRole).forEach(node=>shapesInside(node).forEach(shape=>wrapMap.set(shape,colorRole)));
        }
        role=findPaintedRole(wrapMap);
      }
    }finally{
      saved.forEach(([node,value])=>{node.style.pointerEvents=value;});
    }
    return role;
  }

  editor.addEventListener("pointerdown",event=>{
    if(!event.target.closest(".sled-svg-wrapper"))return;
    pointerStart={id:event.pointerId,x:event.clientX,y:event.clientY};
    clickAllowed=true;
  },true);

  editor.addEventListener("pointerup",event=>{
    if(!pointerStart||pointerStart.id!==event.pointerId)return;
    clickAllowed=Math.hypot(event.clientX-pointerStart.x,event.clientY-pointerStart.y)<=12;
    pointerStart=null;
  },true);

  editor.addEventListener("pointercancel",()=>{
    pointerStart=null;
    clickAllowed=false;
  },true);

  editor.addEventListener("click",event=>{
    if(!event.target.closest(".sled-svg-wrapper"))return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(!clickAllowed)return;
    const role=roleAtPoint(event.clientX,event.clientY);
    if(role)activateRole(role);
  },true);

  editor.querySelector(".sled-svg-wrapper svg #m7-zone-hit-layer")?.remove();
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",()=>setTimeout(m7InstallSvgZonePicker,400));
}else setTimeout(m7InstallSvgZonePicker,400);
document.addEventListener("shopify:section:load",()=>setTimeout(m7InstallSvgZonePicker,150));
